import React from 'react';
import { Navbar } from '../components/Navbar';
import { ConsularAffairs } from '../components/ConsularAffairs';
import { Footer } from '../components/Footer';
import { FeedbackPopup } from '../components/FeedbackPopup';
export function ConsularPage() {
  return <div className="font-nunito w-full min-h-screen overflow-x-hidden" data-id="element-2677">
      <Navbar data-id="element-2678" />
      <main data-id="element-2679">
        <ConsularAffairs data-id="element-2680" />
      </main>
      <Footer data-id="element-2681" />
      <FeedbackPopup data-id="element-2682" />
    </div>;
}